import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=458f09ce&scoped=true"
import script from "./FileDropZone.vue?vue&type=script&lang=ts"
export * from "./FileDropZone.vue?vue&type=script&lang=ts"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=458f09ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f09ce",
  null
  
)

export default component.exports